module.exports = __webpack_public_path__ + "img/success-with-dg-woodpacking-en.4d83a352.svg";